import { Base_Url } from "../../BaseURL/BaseUrl";
import {
  getApiWithAuthorization,
  postApiWithAuthorization,
} from "../ApiMethods/ApiMethod";

const LeaveTypeUrl = `${Base_Url}/Status`;

export const GetStatusList = async (params) => {
  const res = await postApiWithAuthorization(
    `${LeaveTypeUrl}/GetStatusList`,
    params
  );
  return res;
};

export const AddUpdateStatus = async (params) => {
  const res = await postApiWithAuthorization(
    `${LeaveTypeUrl}/AddUpdateStatus?ModuleName=${params.ModuleName}`,
    params
  );
  return res;
};
export const GetStatusModel = async (ModuleName, KeyID, adminKeyID) => {
  const res = await getApiWithAuthorization(
    `${LeaveTypeUrl}/GetStatusModel?ModuleName=${ModuleName}&adminKeyID=${adminKeyID}&StatusKeyID=${KeyID}`
  );
  return res;
};

export const ChangeStatusStatus = async (ModuleName, KeyID, adminKeyID) => {
  const res = await getApiWithAuthorization(
    `${LeaveTypeUrl}/ChangeStatusStatus?ModuleName=${ModuleName}&adminKeyID=${adminKeyID}&StatusKeyID=${KeyID}`
  );
  return res;
};

export const DeleteStatus = async (ModuleName, KeyID, adminKeyID) => {
  const res = await getApiWithAuthorization(
    `${LeaveTypeUrl}/DeleteStatus?ModuleName=${ModuleName}&adminKeyID=${adminKeyID}&StatusKeyID=${KeyID}`
  );
  return res;
};
